/* Rugged Print tracking bridge (v2, 2026-10-24).
   1) Guarantees window.dataLayer and pushes one rp_page event per page (page type from the URL).
   2) Remembers the contact details a visitor types into any Rugged Print form (email, phone, name), in memory only, and
      when a form is submitted successfully (a dataLayer event ending in lead_submit) it hashes them with SHA-256 in the
      browser (lowercase, trimmed, phone as digits with country code) and publishes ONE Shopify custom event, rp_lead,
      carrying the hashed values. The store's custom pixel "Rugged Print Lead" sends them to Meta as advanced matching
      (em, ph, fn, ln, external_id) so the Lead event matches the right person. The hashed values are also pushed to
      dataLayer as user_data for Google enhanced conversions. Plain text is never stored or sent. */
(function(){
  if (window.__rpTrack) return; window.__rpTrack = true;
  var dl = window.dataLayer = window.dataLayer || [];
  var path = location.pathname, type = 'other';
  if (path === '/') type = 'home'; else if (/^\/collections\//.test(path)) type = 'collection';
  else if (/^\/products\//.test(path)) type = 'product'; else if (/^\/pages\//.test(path)) type = 'page'; else if (/^\/cart/.test(path)) type = 'cart';
  var mem = {};
  function pub(name, data){ try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data || {}); } catch (e) {} }
  function hex(buf){ var a = new Uint8Array(buf), s = '', i; for (i = 0; i < a.length; i++) s += ('0' + a[i].toString(16)).slice(-2); return s; }
  function sha(v){
    if (!v || !(window.crypto && crypto.subtle && window.TextEncoder)) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(v)).then(hex, function(){ return ''; });
  }
  function normPhone(p){ var d = String(p || '').replace(/\D/g, ''); if (d.length === 10) d = '1' + d; return d.length >= 11 ? d : ''; }
  function capture(form){
    try {
      var els = [].slice.call(form.elements || []);
      els.forEach(function(el){
        var n = (el.name || '') + ' ' + (el.id || ''), v = (el.value || '').trim(); if (!v) return;
        if (el.type === 'email' || /email/i.test(n)) mem.em = v.toLowerCase();
        else if (el.type === 'tel' || /phone/i.test(n)) mem.ph = normPhone(v);
        else if (/(^|[\[\s_-])(full)?name([\]\s_-]|$)/i.test(n) && el.type !== 'hidden' && !/business|company|file/i.test(n)) { var p = v.split(/\s+/); mem.fn = p[0].toLowerCase(); if (p.length > 1) mem.ln = p.slice(1).join(' ').toLowerCase(); }
      });
    } catch (e) {}
  }
  function gtagUser(){ if (typeof window.gtag !== 'function' || !mem.em) return; Promise.all([sha(mem.em), sha(mem.ph), sha(mem.fn), sha(mem.ln)]).then(function(h){ var ud = { sha256_email_address: h[0] }; if (h[1]) ud.sha256_phone_number = h[1]; if (h[2]) ud.address = { sha256_first_name: h[2], sha256_last_name: h[3] || '' }; try { window.gtag('set', 'user_data', ud); } catch (x) {} }); }
document.addEventListener('submit', function(e){ if (e.target && e.target.elements) { capture(e.target); gtagUser(); } }, true);
  document.addEventListener('change', function(e){ var f = e.target && e.target.form; if (f) capture(f); }, true);

  function leadEvent(o){
    var d = o.rp_detail || {};
    var saved = {}; try { saved = JSON.parse(localStorage.getItem('rp_uid_h') || '{}'); } catch (x) {}
    Promise.all([sha(mem.em), sha(mem.ph), sha(mem.fn), sha(mem.ln)]).then(function(h){
      var u = { em: h[0] || saved.em || '', ph: h[1] || saved.ph || '', fn: h[2] || saved.fn || '', ln: h[3] || saved.ln || '' };
      try { localStorage.setItem('rp_uid_h', JSON.stringify(u)); } catch (x) {}
      var detail = { form: String(d.form || o.event), page: String(d.page || path), em: u.em, ph: u.ph, fn: u.fn, ln: u.ln };
      pub('rp_lead', detail);
      origPush.call(dl, { event: 'rp_user_data', user_data: { sha256_email_address: u.em, sha256_phone_number: u.ph, address: { sha256_first_name: u.fn, sha256_last_name: u.ln } } });
    });
  }
  var origPush = dl.push;
  dl.push = function(){
    var r = origPush.apply(dl, arguments);
    try { for (var i = 0; i < arguments.length; i++) { var o = arguments[i]; if (o && typeof o.event === 'string' && /lead_submit$/.test(o.event)) leadEvent(o); } } catch (e) {}
    return r;
  };
  dl.push({ event: 'rp_page', rp_page_type: type, rp_path: path, page_location: location.href, page_title: document.title });
})();
